import React, { useContext, useState } from "react";

// ui
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Hidden from "@mui/material/Hidden";
import Typography from "@mui/material/Typography";
//
// components
import Sidebar from "./sidebar/Sidebar";
import SideToolbar from "./sideTool/SideToolbar";
import ConfirmModalHoc from "./dialog/ConfirmModalHoc";
// style

// store
import { StoreContext } from "../../../store/StoreProvider";
import { getMainContent } from "./utils";

// config

// utils

const SnaWorkingArea = () => {
  //
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { sidebar, subPage } = sna;
  //
  const mainInner = getMainContent(sidebar.contentName, subPage);
  // fixme: place Sidebar inside Box
  return (
    <>
      <Hidden mdUp>
        <Box mt={5}>
          <Typography variant="h5" textAlign="center">
            不支援平板或行動模式，請使用桌面或筆電系統操作
          </Typography>
        </Box>
      </Hidden>
      <Hidden mdDown>
        <Grid container sx={{ height: "calc(100vh - 64px)" }}>
          <Box
            width="72px"
            borderRight="solid 1px #505050"
            // let sideToolbar always zIndex > Sidebar(1200)
            zIndex={1210}
          >
            <SideToolbar />
          </Box>
          <Grid
            item
            flexGrow={1}
            sx={{
              width: "calc(100vh - 240px)",
            }}
          >
            {/* <Box sx={{ display: "flex", height: "100%" }}> */}
            <Box
              sx={{
                display: "flex",
                height: "calc(100vh - 64px)",
              }}
            >
              <Sidebar />
              {/* <Main /> */}
              {mainInner}
              <ConfirmModalHoc />
            </Box>
          </Grid>
        </Grid>
      </Hidden>
    </>
  );
};

export default SnaWorkingArea;
